<div class="container">
  <div class="header">
    <div class="row">
      <h2>Compare option</h2>
      <button mat-icon-button aria-label="close dialog" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <p>Select 2 regions or markets to compare their data.</p>
  </div>
  <div class="body" *ngIf="!isLoading; else loadingTemplate">
    <span>
      <input
        type="radio"
        name="comparisson-type"
        value="region"
        [(ngModel)]="typeSelected"
        id="by-region"
      />
      <label for="by-region">By region</label>
    </span>

    <span>
      <input
        type="radio"
        name="comparisson-type"
        value="market"
        [(ngModel)]="typeSelected"
        id="by-market"
      />
      <label for="by-market">By market</label>
    </span>

    <div class="checkbox-container regions" *ngIf="typeSelected === 'region'">
      <h3>Select 2 regions:</h3>

      <span *ngFor="let region of regions">
        <input
          type="checkbox"
          id="checkbox-region-{{ region.id }}"
          [(ngModel)]="region.isSelected"
          [disabled]="!region.isSelected && getSelectedRegions().length >= 2"
        />
        <label for="checkbox-region-{{ region.id }}">{{ region.name }}</label>
      </span>
    </div>

    <div class="checkbox-container markets" *ngIf="typeSelected === 'market'">
      <h3>Select 2 markets:</h3>

      <mat-accordion>
        <mat-expansion-panel *ngFor="let region of regions">
          <mat-expansion-panel-header>
            <mat-panel-title> {{ region.name }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="checkbox-container">
            <ng-container *ngFor="let market of markets">
              <span *ngIf="market.region === region.id">
                <input
                  type="checkbox"
                  id="checkbox-market-{{ market.id }}"
                  [(ngModel)]="market.checked"
                  [disabled]="
                    !market.checked && getSelectedMarkets().length >= 2
                  "
                />
                <label for="checkbox-market-{{ market.id }}">{{
                  market.name
                }}</label>
              </span>
            </ng-container>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <hr />
  <div class="footer">
    <button class="secondary" (click)="closeDialog()">Cancel</button>
    <button
      class="fill"
      [disabled]="isApplyDisabled()"
      (click)="applySelection()"
    >
      Apply
    </button>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="loading-container">
    <app-spinner
      [display]="true"
      [class]="'spinner-container'"
      [messageToDisplay]="'Loading regions...'"
    ></app-spinner>
  </div>
</ng-template>
